export default "__VITE_ASSET__2b960680__"